import * as React from "react";
import {connect} from "react-redux";
import {none, option, Option} from "ts-option";
import {RootState} from "../../store/reducer/root/RootState";
import {Icon} from "../../hiberUiKit/src/atoms/Icon/Icon";
import InfoModule from "../../hiberUiKit/src/molecules/InfoModule/InfoModule";
import PartnerBrand, {IPartnerBrandPaymentsStatus} from "../../model/partnerBrand/PartnerBrand"
import "./partnerBrandDisplayer.scss";
import IconSmall from "../../hiberUiKit/src/atoms/Icon/IconSmall";
import IndividualContact from "../../model/contact/IndividualContact";
import Routes from "../../navigation/route/Route";
import {getLoggedUser} from "../../store/view/user";
import * as classNames from "classnames";

interface ComponentProps {
	/**
	 * Contact.
	 */
	contact: Option<IndividualContact>
	/**
	 * If true, automatic payment status indicator is displayed when automatic payment is on.
	 */
	displayAutoPayout?: boolean;
}

interface ReduxProps {
	/**
	 * Selected partner brand.
	 */
	partnerBrand: Option<PartnerBrand>;
	/**
	 * Partner brand payment status
	 */
	partnerBrandPaymentsStatus: Option<IPartnerBrandPaymentsStatus>
	/**
	 * Is logged user admin
	 */
	isLoggedUserAdmin: boolean
}

type Props = ComponentProps & ReduxProps

/**
 * Partner brand displayer.
 */
class PartnerBrandDisplayer extends React.PureComponent<Props> {

	render() {
		let partnerBrandName: string;
		let autoPayoutEnabled: boolean;
		this.props.partnerBrand.map(pb => {
			partnerBrandName = pb.name;
			autoPayoutEnabled = pb.automaticPayment;
		}).getOrElse(() => {
			partnerBrandName = "N/A";
			autoPayoutEnabled = false;
		});

		const classFromProps = classNames({
			"t-body": true,
			"t-link": this.props.isLoggedUserAdmin && this.props.partnerBrand.isDefined
		});

		return (
			<InfoModule icon={Icon.Job} title={"Partner brand"}>
				<span className={classFromProps} onClick={this.navigateToPartnerBrand}>{partnerBrandName}</span>
				{(this.props.displayAutoPayout && autoPayoutEnabled) &&
				<div className="c-partner-brand-displayer_auto-payment">
					{/* TODO: add proper icon and use it */}
					<IconSmall icon={Icon.CheckMark} variant={"orange"}
							   customClass="c-partner-brand-displayer_auto-payment_icon"/>
					AUTO PAYOUT
				</div>}
				{this.props.partnerBrandPaymentsStatus.map(ps => ps.outstandingBills &&
					<div className={"c-partner-brand-displayer_outstanding-bills"}>Outstanding Bills</div>).orNull}
			</InfoModule>
		);
	}

	navigateToPartnerBrand = () => {
		this.props.isLoggedUserAdmin && this.props.partnerBrand.map(pb => window.open(Routes.PartnerBrandEdit(pb.id), "_blank"))
	}
}

function mapStateToProps(state: RootState, componentProps: ComponentProps) {
	if (componentProps.contact.flatMap(c => c.data.partnerBrandId).isEmpty) {
		return {partnerBrand: none, partnerBrandPaymentsStatus: none}
	}
	const partnerBrand = state.partnerBrand.partnerBrandsMap[componentProps.contact.flatMap(c => c.data.partnerBrandId).get];
	const partnerBrandPaymentsStatus = partnerBrand ? option(state.partnerBrand.pBrandPaymentsStatus[partnerBrand.id]) : none;
	return {
		partnerBrand: option(partnerBrand),
		partnerBrandPaymentsStatus,
		isLoggedUserAdmin: getLoggedUser().map(u => u.isAdmin()).getOrElse(false)
	};
}

export default connect(mapStateToProps)(PartnerBrandDisplayer)
